import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=41263516&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=41263516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41263516",
  null
  
)

export default component.exports